export default __webpack_public_path__ + "static/media/globalCard4.c8901b85.webp";